/*
 * Organic Promise: Jenpharm-style header and product page extras (14 Oct 2026).
 * - Adds the "Build Your Bundle" button next to the cart.
 * - Product pages: moves the "Complete your routine" (bought together) box right under
 *   the 1/2/3 pack choice, renames it, and adds the row of product pictures with
 *   + signs between them. Picks still come from op-theme.js (Shopify's
 *   bought-together recommendations). Styling: op-nav.css and op-fbt.css.
 */
(function () {
  'use strict';

  function addBundleButton() {
    var icons = document.querySelector('.section-header .header__icons');
    if (!icons || icons.querySelector('.op-bundle-btn')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var link = document.createElement('a');
    link.href = root + 'collections/bundle-deals';
    link.className = 'op-bundle-btn';
    link.textContent = 'Build Your Bundle';
    var cart = icons.querySelector('#cart-icon-bubble');
    icons.insertBefore(link, cart || null);
  }

  function boughtTogether() {
    var box = document.querySelector('[data-op-fbt]');
    if (!box || box.dataset.opReady) return;
    box.dataset.opReady = '1';

    var anchor = document.querySelector('.product__info-container [data-op-eta]') ||
      document.querySelector('.product__info-container [data-op-packs]');
    if (anchor) anchor.insertAdjacentElement('afterend', box);

    var heading = box.querySelector('h2');
    if (heading) heading.textContent = 'Complete your routine';

    var list = box.querySelector('[data-op-fbt-items]');
    if (!list) return;
    var strip = document.createElement('div');
    strip.className = 'op-fbt__strip';
    strip.setAttribute('aria-hidden', 'true');
    list.parentNode.insertBefore(strip, list);

    function render() {
      var items = list.querySelectorAll('[data-op-fbt-item]');
      strip.innerHTML = '';
      Array.prototype.forEach.call(items, function (item, i) {
        if (i > 0) {
          var plus = document.createElement('span');
          plus.className = 'op-fbt__plus';
          plus.textContent = '+';
          strip.appendChild(plus);
        }
        var input = item.querySelector('input');
        var link = item.querySelector('a');
        var img = item.querySelector('img');
        var pic = document.createElement('a');
        pic.className = 'op-fbt__pic' + (input && !input.checked ? ' is-off' : '');
        pic.href = link ? link.href : '#';
        pic.tabIndex = -1;
        if (img) {
          var copy = img.cloneNode(true);
          copy.className = '';
          copy.removeAttribute('loading');
          pic.appendChild(copy);
        }
        strip.appendChild(pic);
      });
    }

    render();
    new MutationObserver(render).observe(list, {childList: true});
    list.addEventListener('change', render);
  }

  function init() {
    addBundleButton();
    boughtTogether();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
